import type React from 'react';
import styles from './ModalFooter.module.sass';
import classNames from 'classnames';
type ModalFooterProps = {
  className?: string;
  leftContent?: React.ReactNode;
  mainAction?: React.ReactNode;
  secondaryActions?: React.ReactNode[];
  isSecondaryOnlyCompact?: boolean;
};

export const ModalFooter = ({
  className,
  leftContent,
  mainAction,
  secondaryActions,
  isSecondaryOnlyCompact = false,
}: ModalFooterProps) => {
  const hasSecondaryActions = !!secondaryActions && secondaryActions.length > 0;
  const hasMultipleSecondaryActions = !!secondaryActions && secondaryActions.length > 1;
  const hasMainAction = !!mainAction;
  const isSingleSecondaryOnly = hasSecondaryActions && !hasMultipleSecondaryActions && !hasMainAction;

  return (
    <footer
      className={classNames(styles.modalFooter, className, {
        [styles.columnView]: hasMultipleSecondaryActions,
        [styles.singleSecondary]: isSingleSecondaryOnly && !isSecondaryOnlyCompact,
      })}
    >
      {leftContent && <div className={styles.leftContent}>{leftContent}</div>}
      {hasSecondaryActions && secondaryActions?.map((action) => action)}
      {hasMainAction && <div className={styles.mainAction}>{mainAction}</div>}
    </footer>
  );
};
